const accountDetails = {
  accountDetails: {
    managePreferences: 'Modifica preferenze',
    email: 'E-mail',
    emailChangeText: "La modifica dell'indirizzo e-mail non è stata ancora confermata.",
    confirmationText: "Abbiamo inviato un'e-mail di conferma a %{email}. Per rendere valida la modifica dell'indirizzo, è necessario fare clic sul collegamento incluso nel messaggio",
    resendConfirmationEmail: 'Rinvia e-mail di conferma',
    cancelChange: 'Annulla modifica',
    firstName: 'Nome',
    lastName: 'Cognome',
    phone: 'Telefono',
    company: 'Nome azienda',
    saveDetails: 'Salva dettagli account',
    changeEmailRequest: 'Cambia e-mail',
    job_profile: {
      label: "Selezionare il profilo professionale della persona in azienda",
      tooltip_msg: 'Selezionare il profilo professionale principale della persona. Se l\'utente ha più di un ruolo primario, selezionare "Altro".'
    }
  },
  resetPassword: {
    instructions: "La password deve essere lunga almeno 6 caratteri, contenere almeno 1 carattere numerico o speciale e non può corrispondere all'indirizzo e-mail inserito.",
    currentPassword: 'Password corrente',
    newPassword: 'Immettere la nuova password',
    confirmNewPassword: 'Confermare la nuova password',
  }
};

export default accountDetails;